<template>
  <div>
    <main-info-section />
    <hr />
    <publication-info-section />
    <hr />
    <hq-section />
    <hr />
    <docs-section />
  </div>
</template>

<script>
import HqSection from "../../components/HqSection.vue";
import MainInfoSection from "../../components/MainInfoSection.vue";
import PublicationInfoSection from "../../components/PublicationInfoSection.vue";
import DocsSection from "../../components/DocsSection.vue";

export default {
  components: {
    HqSection,
    MainInfoSection,
    PublicationInfoSection,
    DocsSection,
  },
};
</script>
